import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentStarOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.8 21.2V2.8H13c2.9 0 4.261.507 4.977 1.223S19.2 6.1 19.2 9v12.2zM21 23H3V1h10c6 0 8 2 8 8zM9.33 13.846l.582.242.242.581C10.94 16.556 11.334 17.5 12 17.5s1.06-.944 1.846-2.83l.242-.582.581-.242C16.556 13.06 17.5 12.666 17.5 12s-.944-1.06-2.83-1.846l-.582-.242-.242-.581C13.06 7.444 12.666 6.5 12 6.5s-1.06.944-1.846 2.83l-.242.582-.581.242C7.444 10.94 6.5 11.334 6.5 12s.944 1.06 2.83 1.846"
                fill="currentColor"
            />
        </g>
    </svg>
));
DocumentStarOutlinedSize24Glyph.displayName = 'DocumentStarOutlinedSize24Glyph';
